// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.
export { RESIZE_HANDLE_AREA_DECORATION_GAP, TableDecorations, TableCssClassName, ShadowEvent } from '@atlaskit/editor-plugin-table/types';